<template>
    <common-modal width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="small">
            <common-calendar-x-event :calendarEvent="calendarEvent" :showFullData="true"></common-calendar-x-event>
            <common-buttons>
                <common-button
                    type="primary"
                    :label="$t('common.microcopy.view_details')"
                    @click="goToOfferDetails()"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import CommonContentSpacer from '../../common/page/CommonContentSpacer.vue'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        components: { CommonContentSpacer },
        props: {
            calendarEvent: { type: Object, required: true },
        },
        methods: {
            goToOfferDetails() {
                this.$router.push({ name: RoutesEnum.RESERVATIONS.SINGLE, params: { id: this.calendarEvent.id } })
            },
        },
    }
</script>
